module.exports = __webpack_public_path__ + "img/12.33c84b69.png";